import apiV2 from '.'

export const rolesApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    getMyRoles: builder.query({
      query: ({ domainId }) => `/domains/${domainId}/roles/me`,
      transformResponse: response => response.data?.roles,
    }),
  }),
})

export const { useGetMyRolesQuery } = rolesApi
